import AccessWorkspace from 'components/access/AccessWorkspace';
import TmsCustomerGate, { useTmsCustomer } from 'components/TmsCustomerGate';
import TmsPersonalAccount from 'components/TmsPersonalAccount';
import TmsCustomerPortal from 'components/TmsCustomerPortal';
function CarrierFlowAccount() {
  const customer = useTmsCustomer();
  return <TmsCustomerGate><TmsPersonalAccount key={customer.user?.uid}>{accountId => <TmsCustomerPortal key={`${customer.user?.uid}:${accountId}`} accountId={accountId} />}</TmsPersonalAccount></TmsCustomerGate>;
}
export default function CustomerAccessPage() {
  return <AccessWorkspace paid={<CarrierFlowAccount />} />;
}
